<script lang="ts">
	import type { ChainData } from '#lib/models/index.js'
	import { m } from '#lib/paraglide/messages.js'

	let {
		leftChain,
		rightChain,
		leftValue,
		rightValue,
		ratio,
		prettyRatio,
		prettyLeftValue,
		prettyRightValue,
		metric,
		metricSingular,
	}: {
		leftChain: ChainData
		rightChain: ChainData
		leftValue?: Nullable<number>
		rightValue?: Nullable<number>
		ratio: Nullable<number>
		prettyRatio: string
		prettyLeftValue: string
		prettyRightValue: string
		metric: string
		metricSingular: string
	} = $props()
</script>

{#if leftValue != null && rightValue != null && ratio != null}
	{#if !Number.isFinite(ratio)}
		{m.chain_page_compare_counts({
			leftChain: leftChain.name,
			leftValue: prettyLeftValue,
			leftMetric: leftValue === 1 ? metricSingular : metric,
			rightChain: rightChain.name,
			rightValue: prettyRightValue,
			rightMetric: rightValue === 1 ? metricSingular : metric,
		})}
	{:else if ratio > 1}
		{m.chain_page_compare_dev_activity_left_better({
			leftChain: leftChain.name,
			prettyRatio,
			rightChain: rightChain.name,
			metric,
		})}
	{:else if ratio < 1}
		{m.chain_page_compare_dev_activity_right_better({
			leftChain: leftChain.name,
			prettyRatio,
			rightChain: rightChain.name,
			metric,
		})}
	{:else}
		{m.chain_page_compare_dev_activity_same({
			leftChain: leftChain.name,
			rightChain: rightChain.name,
			metric,
		})}
	{/if}
{:else if leftValue == null && rightValue == null}
	{m.chain_page_compare_dev_activity_no_both({
		leftChain: leftChain.name,
		rightChain: rightChain.name,
	})}
{:else if leftValue != null && rightValue == null}
	{m.chain_page_compare_dev_activity_no_right({
		leftChain: leftChain.name,
		rightChain: rightChain.name,
		metric: leftValue === 1 ? metricSingular : metric,
		leftValue: prettyLeftValue,
	})}
{:else if leftValue == null && rightValue != null}
	{m.chain_page_compare_dev_activity_no_left({
		leftChain: leftChain.name,
		rightChain: rightChain.name,
		metric: rightValue === 1 ? metricSingular : metric,
		rightValue: prettyRightValue,
	})}
{/if}
